import moment from 'moment';

const formatDateDisplay = 'DD-MM-YYYY HH:mm';
export function formatDate(
  date: string | Date | undefined,
  format = formatDateDisplay
) {
  return date ? moment(date).format(format) : '';
}
